import { render, staticRenderFns } from "./DefaultContent.vue?vue&type=template&id=8ba300f6&scoped=true"
import script from "./DefaultContent.vue?vue&type=script&lang=ts"
export * from "./DefaultContent.vue?vue&type=script&lang=ts"
import style0 from "./DefaultContent.vue?vue&type=style&index=0&id=8ba300f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba300f6",
  null
  
)

export default component.exports